const ADMINISTRATION_ROOT = "/administration";

/**
 * Where a practice switch started from `pathname` should land.
 *
 * Inside Administration it returns the section list page, e.g.
 * `/administration/users/123` becomes `/administration/users`: the record id
 * belonged to the old practice and would 404 in the new one, but the section
 * exists in every practice. Anywhere else it returns null and the switch lands
 * on the home route as before.
 */
export function switchReturnPath(pathname: string): string | null {
  if (
    pathname !== ADMINISTRATION_ROOT &&
    !pathname.startsWith(`${ADMINISTRATION_ROOT}/`)
  ) {
    return null;
  }
  const section = pathname.slice(ADMINISTRATION_ROOT.length + 1).split("/")[0];
  return section ? `${ADMINISTRATION_ROOT}/${section}` : ADMINISTRATION_ROOT;
}
